export default __webpack_public_path__ + "static/media/covid.49009db6.png";